import { NextImageProps } from '~components/NextImage/NextImage.types';
import { PropsWithId } from '~types/Props.types';

export type ArticleCategory = PropsWithId<{
  title: string;
  href?: string;
  count?: number;
  pageCategoryId?: number;
}>;

export type ArticleAuthor = {
  name: string;
  image?: NextImageProps;
};

export type Article = PropsWithId<{
  title: string;
  href: string;
  publishedAt: string;
  imageWithBg?: boolean;
  author?: ArticleAuthor;
  image?: NextImageProps;
  text?: string;
  categories?: ArticleCategory[];
  updatedAt?: string;
}>;

export enum ArticleCardImagePosition {
  Top = 'top',
  Bottom = 'bottom',
}

export enum ArticleCardMods {
  Wide = 'wide',
}
